import { useEffect } from 'react';

import { ERoutes } from 'app/providers/routing';
import { IPartnerRouterContext } from 'contexts/PartnerRouter/PartnerRouterContext';

const markAsCustomized = (element: Element) => element.setAttribute('data-customized', 'true');
const getIsCustomized = (element: Element) => element.getAttribute('data-customized') === 'true';

const customizeGiveConsent = (content: Element) => {
    const giveConsentContent = content?.querySelector(
        '[data-action="give-consent"] .gdpr-checkbox__content'
    );
    if (giveConsentContent && !getIsCustomized(giveConsentContent)) {
        const [message, description] = giveConsentContent.innerHTML.split('{desc}');
        giveConsentContent.innerHTML = `${message}<span class="gdpr-give-consent--description">${description}</span>`;
        markAsCustomized(giveConsentContent);
    }
};

const customizeGDPRBanner = (content: Element, getRoute: IPartnerRouterContext['getRoute']) => {
    customizeGiveConsent(content);
};

export const customizeGDPRBannerOnMutate = (
    formElement: Element | null,
    getRoute: IPartnerRouterContext['getRoute']
) => {
    const content = formElement?.children[0];
    if (!content) {
        return;
    }

    const observer = new MutationObserver(() => {
        if (content) {
            customizeGDPRBanner(content, getRoute);
        }
        observer.disconnect();
    });

    observer.observe(content, { childList: true });
};

export const customizeGDPRBannerOnShow = (
    formElement: Element | null,
    getRoute: IPartnerRouterContext['getRoute']
) => {
    setTimeout(() => {
        const content = formElement?.children[0];
        if (content) {
            customizeGDPRBanner(content, getRoute);
        }
    }, 0);
};

export const useStory3CookieLinks = (getRoute: IPartnerRouterContext['getRoute']) => {
    useEffect(() => {
        const gdprContainerSelector = '#gdpr-consent-form';

        const cookieLinkSelector = '.gdpr-settings-content a[href="https://xsolla.com/cookie"]';

        const observer = new MutationObserver(() => {
            setTimeout(() => {
                const gdprContainer = document.querySelector(gdprContainerSelector) as HTMLElement;
                const cookieLink = gdprContainer?.querySelector(
                    cookieLinkSelector
                ) as HTMLAnchorElement;
                if (!cookieLink) {
                    return;
                }

                cookieLink.href = getRoute(ERoutes.CookieStatement);
            }, 0);
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        return () => {
            observer.disconnect();
        };
    }, []);
};
